import { render, staticRenderFns } from "./HorseTaille.vue?vue&type=template&id=09d5ce1e&"
import script from "./HorseTaille.vue?vue&type=script&lang=js&"
export * from "./HorseTaille.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports